import {MODULE_CONFIG} from "../config";
import {
    PlatformSession,
    RememberedAccount
} from "../types.ts";

type PlatformSessionMap = { [poolId: string]: PlatformSession };

const readJson = <T>(key: string): T | null => {
    const raw = localStorage.getItem(key);
    if (raw === null) {
        return null;
    }
    try {
        return JSON.parse(raw) as T;
    } catch {
        localStorage.removeItem(key);
        return null;
    }
};

const readSessions = (): PlatformSessionMap => readJson<PlatformSessionMap>(MODULE_CONFIG.platformSessionsKey) ?? {};

const writeSessions = (sessions: PlatformSessionMap) => {
    if (Object.keys(sessions).length === 0) {
        localStorage.removeItem(MODULE_CONFIG.platformSessionsKey);
        return;
    }
    localStorage.setItem(MODULE_CONFIG.platformSessionsKey, JSON.stringify(sessions));
};

export const readPlatformSessions = (): PlatformSession[] => Object.values(readSessions());

export const readPlatformSession = (poolId: string): PlatformSession | null => readSessions()[poolId] ?? null;

export const savePlatformSession = (session: PlatformSession) => {
    const sessions = readSessions();
    sessions[session.poolId] = session;
    writeSessions(sessions);
};

export const discardPlatformSession = (poolId: string) => {
    const sessions = readSessions();
    if (!(poolId in sessions)) {
        return;
    }
    delete sessions[poolId];
    writeSessions(sessions);
};

export const readRememberedAccount = (): RememberedAccount | null => readJson<RememberedAccount>(MODULE_CONFIG.rememberedAccountKey);

export const saveRememberedAccount = ({email, poolId, identityProvider}: RememberedAccount) => {
    const record: RememberedAccount = identityProvider ? {email, poolId, identityProvider} : {email, poolId};
    localStorage.setItem(MODULE_CONFIG.rememberedAccountKey, JSON.stringify(record));
};
